import type { TFunction } from 'i18next';

/** Respaldo por `order` solo si el catálogo no trae nombre. */
const ORDER_TO_I18N_KEY: Record<number, string> = {
  1: 'inventoryPolicies.statusBadges.obsolete',
  2: 'inventoryPolicies.statusBadges.overstock',
  3: 'inventoryPolicies.statusBadges.optimal',
  4: 'inventoryPolicies.statusBadges.breakageRisk',
  5: 'inventoryPolicies.statusBadges.noStock',
};

function isItalianLocale(locale?: string | null): boolean {
  return (locale ?? '').toLowerCase().startsWith('it');
}

/**
 * Etiqueta de estado de stock según idioma de la UI.
 * - Italiano: prioriza `StockStatus.name` de BD (catálogo operativo).
 * - Español y demás: i18n por `order` (la BD puede mezclar IT/EN en `name`).
 */
export function translateStockStatusLabel(
  t: TFunction,
  order?: number | null,
  catalogName?: string | null,
  locale?: string | null,
): string {
  const trimmed = catalogName?.trim();

  if (isItalianLocale(locale)) {
    if (trimmed) return trimmed;
    if (order != null && ORDER_TO_I18N_KEY[order]) {
      return t(ORDER_TO_I18N_KEY[order]);
    }
    return t('inventoryPolicies.table.noStockStatus');
  }

  if (order != null && ORDER_TO_I18N_KEY[order]) {
    return t(ORDER_TO_I18N_KEY[order]);
  }
  if (trimmed) return trimmed;
  return t('inventoryPolicies.table.noStockStatus');
}
